window.addEventListener('load', function () {
  function observeWaypoints() {
    const observerOptions = {
      threshold: 0.4
    }

    const waypoints = document.querySelectorAll('.waypoint')

    if (!waypoints.length) {
      return
    }

    const observer = new IntersectionObserver(function (entries, observer) {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return
        }
        entry.target.classList.add('visible')
      }, observerOptions)
    })

    waypoints.forEach((waypoint) => observer.observe(waypoint))
  }

  observeWaypoints()
})
